<template>
  <div class="wrapper-title">
    <p class="title">{{ title }}</p>
    <img
      src="assets/administrator/LineDetail.svg"
      alt="detail-line"
      class="line"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, Ref, watch } from "vue";

export default defineComponent({
  name: "ContentTitle",
  props: {
    title: {
      type: String,
      required: true,
    },
  },

  setup() {
    return {};
  },
});
</script>

<style scoped lang="scss">
.wrapper-title {
  grid-column: 2/3;
  grid-row: 1/2;
  font-size: 1.5rem;
  color: #d3af4a;
  font-weight: 500;
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  column-gap: 1.5rem;
  padding: 0 1.5rem;

  .line {
    width: 100%;
  }
}
</style>
